<!-- 首页 -->
<template>
  <div class="frame">
    <!-- 首页轮播 -->
    <div class="banner" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
          <img :src="item.img" class="slogan" />
          <div class="slide-text">
            <div class="tag" v-if="item.tag">{{ item.tag }}</div>
            <div class="title">{{ item.title }}</div>
            <div class="sub" v-if="item.sub">{{ item.sub }}</div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <!-- 关于我们 -->
    <div class="box1">
      <div class="about-wrap">
        <div class="about-left">
          <div class="about-label wow animate__fadeInUp">
            {{ $t("home.about.en") }}
          </div>
          <h2 class="about-heading wow animate__fadeInUp" data-wow-delay="0.1s">
            {{ $t("home.about.title") }}
          </h2>
          <div class="about-body wow animate__fadeInUp" data-wow-delay="0.2s">
            <p class="about-desc">
              <span class="about-highlight">{{ $t("about.p1Highlight") }}</span
              >{{ $t("about.p1Text") }}
            </p>
            <div class="about-item">
              <div class="about-icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <path
                    d="M3 12h18M12 3c2.8 3.2 4.3 7.1 4.3 9s-1.5 5.8-4.3 9M12 3c-2.8 3.2-4.3 7.1-4.3 9s1.5 5.8 4.3 9"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div class="about-item-content">
                <h3 class="about-item-title">{{ $t("about.p2Title") }}</h3>
                <p class="about-desc">{{ $t("about.p2Text") }}</p>
              </div>
            </div>
            <div class="about-item">
              <div class="about-icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4l7.5 4.33L12 12.66 4.5 8.33 12 4z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.5 11.5L12 15.83l6.5-4.33M5.5 15.5L12 19.83l6.5-4.33"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="about-item-content">
                <h3 class="about-item-title">{{ $t("about.p3Title") }}</h3>
                <p class="about-desc">{{ $t("about.p3Text") }}</p>
              </div>
            </div>
          </div>
          <div
            class="about-btn-wrap wow animate__fadeInUp"
            data-wow-delay="0.3s"
          >
            <button type="button" class="about-btn" @click="openContactForm">
              {{ $t("nav.contact") }}
            </button>
          </div>
        </div>
        <div class="about-gallery wow animate__fadeIn" data-wow-delay="0.4s">
          <div
            class="about-gallery-cell"
            v-for="(img, index) in aboutImages"
            :key="index"
          >
            <img :src="img" class="about-gallery-item" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 精选旅游目的地 -->
    <DestinationSection />
    <!-- 一站式旅游服务 -->
    <div class="box3">
      <div class="guide-section-head">
        <div class="guide-section-label wow animate__fadeInUp">
          {{ $t("home.travelGuide.en") }}
        </div>
        <h2
          class="guide-section-title wow animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          {{ $t("home.travelGuide.title") }}
        </h2>
      </div>
      <div class="guide-list">
        <router-link
          :to="'/guide/' + item.key"
          class="guide-card wow animate__fadeInUp"
          v-for="(item, index) in guideItemList"
          :key="item.key"
          :data-wow-delay="
            index > 0 ? Math.min(index * 0.08, 0.5) + 's' : undefined
          "
        >
          <img :src="item.img" class="post" :alt="item.title" />
          <div class="describ">
            <div class="title">{{ item.title }}</div>
            <div class="sub">{{ item.desc }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div class="box4">
      <div class="why-section-head">
        <div class="why-section-label wow animate__fadeInUp">
          {{ $t("home.whyChoose.en") }}
        </div>
        <h2
          class="why-section-title wow animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          {{ $t("home.whyChoose.title") }}
        </h2>
      </div>
      <div class="why-list">
        <div
          class="why-item wow animate__fadeInUp"
          v-for="(item, index) in whyChooseList"
          :key="index"
          :data-wow-delay="
            index > 0 ? Math.min(index * 0.08, 0.5) + 's' : undefined
          "
        >
          <img :src="item.img" class="why-card-img" :alt="item.title" />
          <h3 class="why-card-title">{{ item.title }}</h3>
          <p class="why-card-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <!-- 客户评价 -->
    <div id="testimonials" class="box5">
      <div class="review-section-head">
        <div class="review-section-label wow animate__fadeInUp">
          {{ $t("home.reviews.en") }}
        </div>
        <h2
          class="review-section-title wow animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          {{ $t("home.reviews.title") }}
        </h2>
      </div>
      <p class="review-intro wow animate__fadeInUp" data-wow-delay="0.15s">
        {{ $t("home.reviews.intro") }}
      </p>
      <div class="platform-row wow animate__fadeInUp" data-wow-delay="0.2s">
        <div
          class="platform-card"
          v-for="platform in reviewPlatforms"
          :key="platform.id"
        >
          <div class="platform-logo" :class="'platform-logo--' + platform.id">
            <img
              v-if="platform.logo"
              :src="platform.logo"
              :alt="platform.name"
            />
            <span v-else class="platform-logo-text">{{ platform.name }}</span>
          </div>
          <div class="platform-info">
            <div class="platform-name">{{ platform.name }}</div>
            <!-- <div class="platform-rating-label">{{ platform.ratingLabel }}</div> -->
          </div>
        </div>
      </div>
      <div class="review-columns wow animate__fadeInUp" data-wow-delay="0.3s">
        <div
          class="review-column"
          v-for="platform in reviewPlatforms"
          :key="'col-' + platform.id"
        >
          <div class="review-scroll">
            <div
              class="review-block"
              v-for="(review, rIdx) in platform.reviews"
              :key="rIdx"
            >
              <div class="review-meta">
                <span class="review-author">{{ review.author }}</span>
                <span class="review-date">{{ review.date }}</span>
              </div>
              <div class="review-stars" :class="'stars--' + platform.starTheme">
                <i
                  v-for="n in review.rating"
                  :key="n"
                  class="el-icon-star-on"
                ></i>
              </div>
              <h4 class="review-block-title" v-if="review.title">
                {{ review.title }}
              </h4>
              <p class="review-content">{{ review.content }}</p>
              <div class="review-images" v-if="review.image">
                <img :src="review.image" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系表单 -->
    <div class="box7">
      <ContactFormBanner
        class="wow animate__fadeInUp"
        style="width: 1200px; max-width: 100%; margin: 0 auto"
      />
    </div>

    <ContactFormModal :visible.sync="contactFormVisible" />
  </div>
</template>

<script>
import { enrichReviewPlatforms } from "@/utils/reviewAssets";
import ContactFormBanner from "@/components/ContactFormBanner.vue";
import ContactFormModal from "@/components/ContactFormModal.vue";
import DestinationSection from "@/components/DestinationSection.vue";

const BANNER_IMGS = [
  require("@/assets/source/banner1.jpg"),
  require("@/assets/source/banner2.jpg"),
  require("@/assets/source/banner3.jpg"),
  require("@/assets/source/banner4.jpg"),
];

const ABOUT_IMGS = [
  require("@/assets/about/01.jpg"),
  require("@/assets/about/02.jpg"),
  require("@/assets/about/03.jpg"),
  require("@/assets/about/04.jpg"),
];

const GUIDE_KEYS = ["bcfw", "cjly", "qzbl", "gnly", "qydz", "srdz"];
const GUIDE_IMGS = [
  require("@/assets/source/bcfw.jpg"),
  require("@/assets/source/jdyd.jpg"),
  require("@/assets/source/qzbl.jpg"),
  require("@/assets/source/mpyd.jpg"),
  require("@/assets/source/zgwd.jpg"),
  require("@/assets/source/ztly.jpg"),
];

const WHY_CHOOSE_IMGS = [
  require("@/assets/choice/desc1.jpg"),
  require("@/assets/choice/desc2.jpg"),
  require("@/assets/choice/desc3.jpg"),
  require("@/assets/choice/desc4.jpg"),
];

export default {
  components: { ContactFormBanner, ContactFormModal, DestinationSection },
  data() {
    return {
      bannerSwiper: null,
      aboutImages: ABOUT_IMGS,
      contactFormVisible: false,
    };
  },
  computed: {
    bannerList() {
      const texts = this.$t("home.banner");
      return texts.map((item, index) => ({
        id: index + 1,
        img: BANNER_IMGS[index],
        tag: item.tag,
        title: item.title,
        sub: item.sub,
      }));
    },
    guideItemList() {
      return GUIDE_KEYS.map((key, index) => ({
        key,
        img: GUIDE_IMGS[index],
        title: this.$t(`home.travelGuide.items.${key}.title`),
        desc: this.$t(`home.travelGuide.items.${key}.desc`),
      }));
    },
    whyChooseList() {
      const items = this.$t("home.whyChoose.items");
      return items.map((item, index) => ({
        ...item,
        img: WHY_CHOOSE_IMGS[index],
      }));
    },
    reviewPlatforms() {
      return enrichReviewPlatforms(this.$t("home.reviews.platforms"));
    },
  },
  watch: {
    "$i18n.locale"() {
      this.$nextTick(() => this.onBannerSlideChange());
    },
  },
  created() {},
  mounted() {
    new this.$wow.WOW().init();

    this.bannerSwiper = new window.Swiper("#banner", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      on: {
        init: () => this.onBannerSlideChange(),
        slideChangeTransitionStart: () => this.onBannerSlideChange(),
      },
    });
  },
  methods: {
    onBannerSlideChange() {
      const slogans = document.querySelectorAll("#banner .slogan");
      slogans.forEach((el) => {
        el.style.animation = "none";
        el.style.transform = "scale(1)";
      });
      const activeSlogan = document.querySelector(
        "#banner .swiper-slide-active .slogan"
      );
      if (activeSlogan) {
        void activeSlogan.offsetWidth;
        activeSlogan.style.animation = "";
        activeSlogan.style.transform = "";
      }

      const texts = document.querySelectorAll("#banner .slide-text");
      texts.forEach((el) => {
        el.classList.remove("is-visible");
      });
      const activeText = document.querySelector(
        "#banner .swiper-slide-active .slide-text"
      );
      if (activeText) {
        void activeText.offsetWidth;
        activeText.classList.add("is-visible");
      }
    },
    openContactForm() {
      this.contactFormVisible = true;
    },
    navToIntro() {
      this.$router.push("/intro");
    },
  },
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height: 680px;
  color: #fff;
  position: relative;
  overflow: hidden;

  .swiper-slide {
    overflow: hidden;
    position: relative;
  }

  .slogan {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
    transform: scale(1);
    will-change: transform;
    display: block;
  }

  .swiper-slide-active .slogan {
    animation: slogan-zoom 5s ease-out forwards;
  }

  .slide-text {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 10%;
    box-sizing: border-box;
    pointer-events: none;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;

    &.is-visible {
      opacity: 1;
      transform: translateY(0);
      transition: opacity 0.8s ease 0.25s, transform 0.8s ease 0.25s;
    }

    .tag {
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: bold;
      letter-spacing: 2px;
      color: #fec54b;
      text-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);
    }
    .title {
      font-size: 42px;
      font-weight: bold;
      letter-spacing: 3px;
      text-shadow: 0 4px 24px rgba(0, 0, 0, 0.45);
    }

    .sub {
      margin-top: 12px;
      font-size: 16px;
      max-width: 640px;
      line-height: 1.6;
      letter-spacing: 2px;
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);
    }
  }

  :deep(.swiper-pagination) {
    bottom: 20px;
    z-index: 3;
  }

  @media (max-width: 768px) {
    height: 360px;

    .slide-text {
      padding: 0 6%;

      .tag {
        font-size: 16px;
      }

      .title {
        font-size: 28px;
      }

      .sub {
        font-size: 13px;
      }
    }
  }
}

@keyframes slogan-zoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}

.title-box {
  position: relative;
  color: #fff;
  z-index: 10;

  .title {
    font-size: 34px;
    position: relative;
    z-index: 8;
  }
  .en {
    font-size: 40px;
    font-weight: bolder;
    letter-spacing: 3px;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.5),
      transparent
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    left: 0;
    top: -40%;
    z-index: 5;
  }
  .line {
    width: 40px;
    height: 3px;
    margin: 20px 0 30px;
    background-color: $theme;
  }
}
.title-box-center {
  text-align: center;

  .en {
    left: 50%;
    transform: translateX(-50%);
  }
  .line {
    margin: 20px auto 30px;
  }
}

.box1 {
  padding: 100px 0 120px;
  background-color: $box-bg;

  .about-wrap {
    width: 1200px;
    max-width: calc(100% - 80px);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 60px;
  }

  .about-left {
    flex: 1;
    min-width: 0;
    max-width: 560px;
  }

  .about-label {
    font-size: 16px;
    font-weight: 500;
    color: #fdc44b;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  }

  .about-heading {
    margin: 0 0 24px;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.25;
    color: #1a1a1a;
  }

  .about-body {
    margin-bottom: 32px;
  }

  .about-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .about-item-content {
      flex: 1;
      min-width: 0;
    }

    .about-desc {
      margin: 0;
    }
  }

  .about-item-title {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.35;
    color: #1a1a1a;
  }

  .about-icon {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: rgba(253, 196, 75, 0.18);
    color: #fdc44b;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 28px;
      height: 28px;
    }

    .el-icon-office-building {
      font-size: 28px;
    }
  }

  .about-desc {
    margin: 0 0 14px;
    font-size: 15px;
    line-height: 1.75;
    color: #666;
    text-align: justify;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .about-highlight {
    font-weight: 600;
    color: #1a1a1a;
  }

  .about-btn-wrap {
    display: flex;
    justify-content: center;
  }

  .about-btn {
    display: inline-block;
    padding: 14px 36px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    background-color: #f18000;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-family: inherit;
    text-decoration: none;
    transition: background-color 0.3s, transform 0.3s;

    &:hover {
      background-color: #e5b043;
      transform: translateY(-2px);
    }
  }

  .about-gallery {
    flex-shrink: 0;
    // width: 520px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    .about-gallery-cell {
      overflow: hidden;
      border-radius: 16px;
    }

    .about-gallery-item {
      width: 100%;
      height: 320px;
      object-fit: cover;
      display: block;
      transition: transform 0.4s ease;
    }

    .about-gallery-cell:hover .about-gallery-item {
      transform: scale(1.1);
    }
  }

  @media (max-width: 992px) {
    padding: 60px 0 80px;

    .about-wrap {
      flex-direction: column;
      gap: 40px;
    }

    .about-left {
      max-width: 100%;
    }

    .about-heading {
      font-size: 32px;
    }

    .about-gallery {
      width: 100%;
    }
  }
}

.box3 {
  padding: 80px 0 100px;
  background-color: $box-bg;

  .guide-section-head {
    max-width: 1200px;
    margin: 0 auto 48px;
    padding: 0 40px;
    text-align: center;
    box-sizing: border-box;
  }

  .guide-section-label {
    font-size: 16px;
    font-weight: 500;
    color: #fdc44b;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  }

  .guide-section-title {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3;
    color: #1a1a1a;
  }

  .guide-list {
    width: 1200px;
    max-width: calc(100% - 80px);
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .guide-card {
    display: block;
    position: relative;
    overflow: visible;
    padding: 12px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    text-decoration: none;
    transition: box-shadow 0.3s ease;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

      .describ {
        transform: translateY(-60px);
        background-color: #fdc44b;

        .title,
        .sub {
          color: #fff;
        }
      }
    }

    .post {
      width: 100%;
      border-radius: 5px;
      display: block;
    }

    .describ {
      width: 80%;
      margin: 0 auto;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      transition: 0.5s;
      border-radius: 5px;
      position: relative;
      z-index: 1;

      .title {
        font-size: 15px;
        font-weight: 600;
        color: #1a1a1a;
      }

      .sub {
        color: #666;
        font-size: 14px;
        margin-top: 10px;
        line-height: 1.6;
      }
    }
  }

  @media (max-width: 992px) {
    .guide-section-title {
      font-size: 26px;
    }

    .guide-section-label {
      font-size: 14px;
    }

    .guide-list {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 576px) {
    .guide-list {
      grid-template-columns: 1fr;
    }
  }
}

.box4 {
  padding: 80px 0 100px;
  background-color: $box-bg;

  .why-section-head {
    max-width: 1200px;
    margin: 0 auto 48px;
    padding: 0 40px;
    text-align: center;
    box-sizing: border-box;
  }

  .why-section-label {
    font-size: 16px;
    font-weight: 500;
    color: #fdc44b;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  }

  .why-section-title {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3;
    color: #1a1a1a;
  }

  .why-list {
    width: 1200px;
    max-width: calc(100% - 80px);
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .why-item {
    display: block;
  }

  .why-card-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 8px;
    display: block;
  }

  .why-card-title {
    margin: 16px 0 12px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.4;
    color: #fdc44b;
    text-align: left;
  }

  .why-card-desc {
    margin: 0;
    font-size: 14px;
    line-height: 1.65;
    color: #666;
    text-align: left;
  }

  @media (max-width: 1200px) {
    .why-list {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 992px) {
    .why-section-title {
      font-size: 26px;
    }

    .why-section-label {
      font-size: 14px;
    }
  }

  @media (max-width: 576px) {
    .why-list {
      grid-template-columns: 1fr;
    }
  }
}

.box5 {
  padding: 80px 0 100px;
  background-color: $box-bg;

  .review-section-head {
    max-width: 1200px;
    margin: 0 auto 24px;
    padding: 0 40px;
    text-align: center;
    box-sizing: border-box;
  }

  .review-section-label {
    font-size: 16px;
    font-weight: 500;
    color: #fdc44b;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  }

  .review-section-title {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3;
    color: #1a1a1a;
  }

  .review-intro {
    max-width: 1200px;
    margin: 0 auto 40px;
    padding: 0 40px;
    font-size: 15px;
    line-height: 1.75;
    color: #666;
    text-align: left;
    box-sizing: border-box;
  }

  .platform-row {
    width: 1200px;
    max-width: calc(100% - 80px);
    margin: 0 auto 24px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .platform-card {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: #f5f5f5;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
  }

  .platform-logo {
    width: 48px;
    height: 48px;
    margin-right: 14px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    background: #fff;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .platform-logo-text {
      font-size: 11px;
      font-weight: 700;
      color: #333;
      text-align: center;
      line-height: 1.2;
      padding: 4px;
    }
  }

  .platform-info {
    .platform-name {
      font-size: 16px;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 4px;
    }

    .platform-rating-label {
      font-size: 14px;
      color: #666;
    }
  }

  .review-columns {
    width: 1200px;
    max-width: calc(100% - 80px);
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }

  .review-column {
    display: flex;
    flex-direction: column;
    min-height: 420px;
    border-right: 1px solid #e8e8e8;

    &:last-child {
      border-right: none;
    }
  }

  .review-scroll {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    max-height: 360px;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .review-block {
    & + .review-block {
      margin-top: 24px;
      padding-top: 24px;
      border-top: 1px solid #eee;
    }
  }

  .review-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;

    .review-author {
      font-weight: 600;
      color: #1a1a1a;
    }

    .review-date {
      color: #999;
    }
  }

  .review-stars {
    margin-bottom: 10px;

    i {
      font-size: 16px;
      margin-right: 2px;
    }

    &.stars--orange i {
      color: #fdc44b;
    }

    &.stars--green i {
      color: #00b67a;
    }
  }

  .review-block-title {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
  }

  .review-content {
    margin: 0;
    font-size: 14px;
    line-height: 1.65;
    color: #555;
  }

  .review-images {
    margin-top: 12px;

    img {
      width: 200px;
      max-width: 100%;
      height: auto;
      border-radius: 6px;
      object-fit: cover;
    }
  }

  @media (max-width: 992px) {
    .review-section-title {
      font-size: 26px;
    }

    .platform-row,
    .review-columns {
      grid-template-columns: 1fr;
    }

    .review-column {
      border-right: none;
      border-bottom: 1px solid #e8e8e8;
      min-height: auto;

      &:last-child {
        border-bottom: none;
      }
    }

    .review-scroll {
      max-height: 280px;
    }
  }
}

.box7 {
  padding: 0 40px 100px;
  background-color: $box-bg;

  :deep(.contact-banner) {
    width: 1200px;
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>